import { HttpCase} from "../Http";
export class CommoncategoryAPI {


  
  public static  getcommoncategory(input: any){

    var url = "/getCommonNameByMeterType?commonName=meter_category" ;
   // alert("url"+url);
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }
 
}
